import { combineReducers } from 'redux';

import geocode from './shared/geocode/geocodeReducer';
import { routerReducer } from 'react-router-redux';

// Route related reducers
import apps from './apps/reducer';
import organizations from './organizations/reducers';
import map from './organizations/reducers/map';
import errors from './errors/reducer';
import pois from './pois/reducer';
import validation from './validation/reducer';
import admin from './admin/reducers';

import organizationPois from './organizations/reducers/organizationPois';

import common from './shared/reducer';

const AppReducers = combineReducers({
  routes: combineReducers({
    organizations,
    apps,
    organizationPois,
    map,
    pois,
    validation,
    admin,
  }),
  geocode,
  common,
  errors,
  router: routerReducer,
});

export default AppReducers;


// WEBPACK FOOTER //
// ./src/rootReducer.js